import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Aarav\\Projects\\relaxing-routine\\app\\blogs\\[slug]\\BlogPostClient.tsx");
